import { QueryClient, type QueryClientConfig } from '@tanstack/react-query';

/**
 * The defaults every Invite app shares: data is fresh for 30 s, a failed query retries once, and
 * returning to the window refetches. An app adds its own per-key defaults on top.
 */
export const createQueryClient = (overrides?: QueryClientConfig['defaultOptions']): QueryClient =>
  new QueryClient({
    defaultOptions: {
      ...overrides,
      queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: true, ...overrides?.queries }
    }
  });
